import NewsReducer from "./reducer";

export const setNewsList = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.setNewsList(payload));
};

export const setNews = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.setNews(payload));
};

export const setViewNews = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.setViewNews(payload));
};

export const openAddUpdateNewsModal = () => (dispatch) => {
  dispatch(NewsReducer.actions.openAddUpdateNewsModal());
};

export const closeAddUpdateNewsModal = () => (dispatch) => {
  dispatch(NewsReducer.actions.closeAddUpdateNewsModal());
};

export const openNewsViewModal = () => (dispatch) => {
  dispatch(NewsReducer.actions.openNewsViewModal());
};

export const openNewsCommentModal = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.openNewsCommentModal(payload));
};

export const closeNewsCommentModal = () => (dispatch) => {
  dispatch(NewsReducer.actions.closeNewsCommentModal());
};

export const closeNewsViewModal = () => (dispatch) => {
  dispatch(NewsReducer.actions.closeNewsViewModal());
};

export const clearViewNews = () => (dispatch) => {
  dispatch(NewsReducer.actions.clearViewNews());
};

export const clearSelectNews = () => (dispatch) => {
  dispatch(NewsReducer.actions.clearSelectNews());
};

export const updateNews = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.updateNews(payload));
};

export const addToList = (payload) => (dispatch) => {
  dispatch(NewsReducer.actions.addToList(payload));
};
